export const setPropKeys = (propName, value) => () => ({
  [propName]: value
})



// WEBPACK FOOTER //
// ./src/utils/setPropKeys.js